import { autoInit } from '@mtfe/sso-web'

const { VUE_APP_SSO_ENV: env, VUE_APP_SSO_CLIENT_ID: clientId } = process.env

if (!env || !clientId) {
  throw new Error(`缺失 SSO 配置信息`)
}

const ssoWebOption = {
  clientId: clientId,
  accessEnv: env === 'production' ? 'product' : 'test', // test or product
  rewriteLocation: '/associate',
}
const ssoGuardOption = {
  clientId: clientId,
  accessEnv: env === 'production' ? 'product' : 'test', // test or product
  appkey: 'com.sankuai.bike.web.epartner',
}
const ssoIntanceObj = autoInit({
  clientId: ssoWebOption.clientId, // 公共配置
  accessEnv: ssoWebOption.accessEnv, // 公共配置
  ssoWebConfigs: ssoWebOption, // 对应SSOWeb
  ssoGuardConfigs: ssoGuardOption, // SSOGuard
})

export { clientId }
export default ssoIntanceObj.ssoWeb
